import {
  Box,
  Container,
  Group,
  Text,
  Avatar,
  Menu,
  UnstyledButton,
} from '@mantine/core';
import {
  IconUser,
  IconCreditCard,
  IconRobot,
  IconPuzzle,
  IconLogout,
  IconChevronDown,
} from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
import { HaiveLogo } from './HaiveLogo';
import { trackNavClick } from '../../analytics';

const activeStyle: React.CSSProperties = {
  backgroundColor: 'rgba(253, 126, 20, 0.08)',
  color: '#fd7e14',
};

export function AppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box
      py="sm"
      style={{
        borderBottom: '1px solid rgba(255,255,255,.05)',
        background: 'rgba(10,10,11,.8)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      <Container size={960} px="md">
        <Group justify="space-between">
          <HaiveLogo h={36} onClick={() => navigate('/dashboard')} />

          {/* Right: User Menu */}
          <Menu shadow="md" width={180} position="bottom-end">
            <Menu.Target>
              <UnstyledButton>
                <Group gap="xs">
                  <Avatar src={user?.photoUrl || null} radius="xl" size="sm" color="orange">
                    {user?.firstName?.[0]?.toUpperCase() || '?'}
                  </Avatar>
                  <Text size="sm" c="dimmed" visibleFrom="sm">{user?.firstName}</Text>
                  <IconChevronDown size={14} color="var(--mantine-color-dimmed)" />
                </Group>
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                leftSection={<IconUser size={14} />}
                onClick={() => { trackNavClick('profile'); navigate('/profile'); }}
                style={location.pathname === '/profile' ? activeStyle : undefined}
              >
                Profile
              </Menu.Item>
              <Menu.Item
                leftSection={<IconRobot size={14} />}
                onClick={() => { trackNavClick('agents'); navigate('/dashboard'); }}
                style={location.pathname === '/dashboard' ? activeStyle : undefined}
              >
                Agents
              </Menu.Item>
              <Menu.Item
                leftSection={<IconPuzzle size={14} />}
                onClick={() => { trackNavClick('skills'); navigate('/skills'); }}
                style={location.pathname === '/skills' ? activeStyle : undefined}
              >
                Skills Marketplace
              </Menu.Item>
              <Menu.Item
                leftSection={<IconCreditCard size={14} />}
                onClick={() => { trackNavClick('billing'); navigate('/billing'); }}
                style={location.pathname === '/billing' ? activeStyle : undefined}
              >
                Billing
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item color="red" leftSection={<IconLogout size={14} />} onClick={() => { trackNavClick('logout'); handleLogout(); }}>
                Logout
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Group>
      </Container>
    </Box>
  );
}
